// extracted by mini-css-extract-plugin
module.exports = {"container":"NewResponsiveImage_container__jhsP2","image":"NewResponsiveImage_image__jURqU"};